import React, { Component } from "react";
import { Upload, Icon } from "antd";

const { Dragger } = Upload;

class ModalUpload extends Component {
  render() {
    const props = {
      name: "file",
      accept: ".csv, text/csv",
      multiple: false,
      action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
      onRemove: file => {
        this.props.fileList(null);
      },
      beforeUpload: file => {
        this.props.fileList(file);
        return true;
      },
    };
    return (
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <Icon type="inbox" style={{ color: "#40a9ff" }} />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">Please upload only csv file</p>
      </Dragger>
    );
  }
}

export default ModalUpload;



// WEBPACK FOOTER //
// src/components/Dashboard/User/Modal/ModalUpload.js